import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "../../utils/axiosinstance";
import { enum_api_uri } from "common/hooks/utils/enum";
import { useAuthStore } from "user/store/useAuthStore";

interface GetCustomerResponse {
    data: {
        member_idx: number;
        m_name: string;
        m_email: string;
        m_mobile: string;
        m_category: number;
        customer_idx: number;
        customer_name: string;
        event_content_option: boolean;
        related_person_option: boolean;
        work_location_option: boolean;
        department_option: boolean;
        union_option: boolean;
        company_tel_option: boolean;
    };
}

export const useGetCustomer = (customerIdx?: number): UseQueryResult<GetCustomerResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetCustomerResponse, Error>({
        queryKey: ["getCustomer", customerIdx],
        queryFn: async () => {
            const response = await axios.get(enum_api_uri.user.get_customer, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data;
        },
    });
};
